<script setup lang="ts">
/**
 * The application kit as an option in a choice (LandingTailorDemo): its name
 * and price, the three things in it, and what the parts sold on their own add
 * up to. The cover letter is not sold on its own, so the sum leaves it out and
 * says so instead of pricing it.
 */
const { t } = useI18n()
const { applicationKitPrice, applicationKitSeparatePrice } = usePremiumPlans()
const items = ['cv', 'letter', 'interview'] as const
</script>

<template>
  <div>
    <span class="tag mb-2">{{ t('landing.builder.kit.badge') }}</span>
    <div class="flex items-baseline justify-between gap-3">
      <span class="font-title text-base font-semibold text-ink dark:text-white">{{ t('landing.builder.kit.title') }}</span>
      <span class="shrink-0 font-title text-2xl font-bold tabular-nums text-ink dark:text-white">{{ applicationKitPrice }}</span>
    </div>
    <ul class="mt-2 space-y-1">
      <li v-for="item in items" :key="item" class="flex items-start gap-2 !text-sm text-body dark:text-gray-300">
        <i class="bi bi-check-lg mt-0.5 shrink-0 text-accent" aria-hidden="true" />
        {{ t(`landing.builder.kit.items.${item}`) }}
      </li>
    </ul>
    <p class="mt-2 !text-sm text-muted dark:text-gray-400">{{ t('landing.builder.kit.separate', { separate: applicationKitSeparatePrice }) }}</p>
  </div>
</template>
